import { atom } from 'jotai';
import { featureCollection } from '@/utils/geometry/helpers';

export const selectedParcellesIduState = atom({});

export const validatedParcellesState = atom(featureCollection());

// Read-only derived atoms: a read function replaces Recoil's `selector`.
export const validatedParcellesIduState = atom((get) => {
  const parcelles = get(validatedParcellesState);
  return parcelles.features.map((p) => p.properties.id);
});

export const validatedAreaState = atom((get) => {
  const parcelles = get(validatedParcellesState);
  return parcelles.features
    .map((p) => (p.properties.contenance ? p.properties.contenance : 0))
    .reduce((acc, cur) => acc + cur, 0);
});

export const isDrawingState = atom(false);

export const shouldShowSelectionDialogState = atom(false);

export const envContraintesState = atom(null);

export const diagnosticParcellesState = atom(null);

export const contactDemandeState = atom(null);
